module.exports = __webpack_public_path__ + "img/ypo-banner.c090cb87.jpg";